import { isBeta } from "./network";

let getWebSocketUrl = () => {
  const wsProtocol = process.env.REACT_APP_PROTOCOL?.endsWith('s') ?
   'wss' : 'ws';
  const url = process.env.REACT_APP_APP_URL;
  let betaAccess = false; //await isBeta();
  let betaFlag = `${betaAccess? '_beta':''}`;
  return `${wsProtocol}:${url}/report-ws${betaFlag}`;
}

let createWebSocket = async () => {
  const webSocketUrl = getWebSocketUrl();
  let ws = new WebSocket(webSocketUrl);
  console.log('Made new websocket.', webSocketUrl);
  return ws;
}

let createWebSocketWithToken = (user) => {
  const webSocketUrl = getWebSocketUrl();
  let ws = new WebSocket(webSocketUrl, ['Authorization', `${user.token}`]);
  console.log('Made new websocket with token.', webSocketUrl);
  return ws;
}

export {
  createWebSocket,
  createWebSocketWithToken
}